import {
  AdditionalFieldEntity,
  AdditionalFieldWithLabel,
} from "@boark/shared/types/additional-field";
import { useMemo } from "react";

import { useGetAssociationContext } from "../queries/get-association-context";

export function useAdditionalFields(): {
  isLoading: boolean;
  data: Record<AdditionalFieldEntity, AdditionalFieldWithLabel[]>;
};
export function useAdditionalFields(entity: AdditionalFieldEntity): {
  isLoading: boolean;
  data: AdditionalFieldWithLabel[];
};
export function useAdditionalFields(entity?: AdditionalFieldEntity): {
  isLoading: boolean;
  data:
    | Record<AdditionalFieldEntity, AdditionalFieldWithLabel[]>
    | AdditionalFieldWithLabel[];
} {
  const { data: association, isLoading } = useGetAssociationContext();
  return {
    isLoading,
    data: useMemo(
      () =>
        !entity
          ? {
              apartment:
                association?.additionalFields?.filter(
                  (field) => field.entity === "apartment",
                ) ?? [],
              holding:
                association?.additionalFields?.filter(
                  (field) => field.entity === "holding",
                ) ?? [],
              lease:
                association?.additionalFields?.filter(
                  (field) => field.entity === "lease",
                ) ?? [],
              organization:
                association?.additionalFields?.filter(
                  (field) => field.entity === "organization",
                ) ?? [],
              person:
                association?.additionalFields?.filter(
                  (field) => field.entity === "person",
                ) ?? [],
              sublet:
                association?.additionalFields?.filter(
                  (field) => field.entity === "sublet",
                ) ?? [],
            }
          : (association?.additionalFields?.filter(
              (field) => field.entity === entity,
            ) ?? []),
      [association, entity],
    ),
  };
}
